import styled from "styled-components";
import { Colors } from "../config/Constants";

type RadioProps = {
  index: number;
  selected: boolean;
  label: string;
  name: string;
  onChange: (change: boolean, index: number) => void;
  fontSize?: any;
};

const Radio = ({
  index,
  selected,
  label,
  name,
  onChange,
  fontSize = "13px",
}: RadioProps) => {
  const handleSelect = (event: any) => {
    const { checked } = event.target;
    onChange(checked, index);
  };
  return (
    <div key={index}>
      <RadioLabel htmlFor={name} fontSize={fontSize}>
        <RadioInput
          type="radio"
          value={label}
          defaultChecked={selected}
          name={name}
          onChange={handleSelect}
        />
        {label}
      </RadioLabel>
    </div>
  );
};

export default Radio;

const RadioInput = styled.input`
  margin: 0.5rem;
  accent-color: ${Colors.appleRed};
`;

interface RadioLabelProps {
  fontSize: string;
}

const RadioLabel = styled.label<RadioLabelProps>`
font-family: "Poppins-Medium";
font-style: normal;
font-weight: 350;
font-size: ${(props) => props.fontSize};
line-height: 16px;
color: ${Colors.electricBlue};
margin-bottom: 0.5rem;
> span {
  color: ${Colors.red};
  margin-left: 2px;
`;
